var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-entity",
    {
      attrs: {
        geometry: "primitive: rounded-plane; width: 0.3; height: 0.3",
        material: "color: #001034;",
        "push-mesh-backwards": "distance: 0.02",
      },
    },
    [
      _c("a-box", {
        attrs: { color: "tomato", depth: "0.2", height: "0.2", width: "0.2" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }